import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserEditRequestBody, UserEditResponse } from "./types";

export class UserEditAPI extends BaseAPI<
  UserEditRequestBody,
  UserEditResponse
> {
  protected route = ApiRoutes.auth.user_edit;
  protected method = RequestMethod.PUT;
}
